import React, { Component } from "react";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as twilioSelector from "../../../common/selectors/twilio";
import * as twilioAction from "../../../common/actions/twilio";
import CustomBoardRenewal from "../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import { Helmet } from "react-helmet";
import CustomBoardFileManagerV2 from "../../components/CustomBoardFileManagerV2";
import LoadingOverlay from "../../components/LoadingOverlay";
import CustomToast from "../../components/CustomToast";
import FileManagerErrorPrompt from "./FileManagerErrorPrompt";

class FileManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      otpNo: "",
      isOnClickNext: false,
      error: false,
      errorMsg: "",
      localFileName: "",
      getFileNameAction: false,
      openCustomToast: false,
      toastMessage: "",
      loadingAction: false,
      seconds: 120,
      localPhone: "your phone",
      showSendOtp: true,
      visibleErrorPrompt: false,
      downloadSuccess: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    sessionStorage.clear();
    localStorage.clear();
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    var fileName = this.getUrlVars()["fileName"];

    this.setState({ localFileName: fileName });
    setInterval(
      function () {
        if (this.state.seconds > 0) {
          this.setState({ seconds: this.state.seconds - 1 });
        }
      }.bind(this),
      1000
    );
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      
      this.state.getFileNameAction === false
    ) {
      const { getTwilioGetFileStatus } = this.props;
      getTwilioGetFileStatus(this.state.localFileName);
      console.log("asd")
      this.setState({ getFileNameAction: true });
    }
    if (
      prevProps.getTwilioGetFileStatusData !==
      this.props.getTwilioGetFileStatusData
    ) {
      const data = twilioSelector.getTwilioGetFileStatusDataData(
        this.props.getTwilioGetFileStatusData
      );
      const status = twilioSelector.getTwilioGetFileStatusDataStatus(data);
      const msg = twilioSelector.getTwilioGetFileStatusDataMessage(data);

      if (status === true) {
        //const { getTwilioRequestOTP } = this.props;
        //getTwilioRequestOTP(this.state.localFileName);
      } else {
        this.setState({
          //openCustomToast: true,
          //toastMessage: msg,
          loadingAction: true,
          visibleErrorPrompt: true,
        });
      }
    }
    if (
      prevProps.getTwilioRequestOTPData !== this.props.getTwilioRequestOTPData
    ) {
      const data = twilioSelector.getTwilioRequestOTPDataData(
        this.props.getTwilioRequestOTPData
      );
      const status = twilioSelector.getTwilioRequestOTPDataStatus(data);
      const phoneNumber = twilioSelector.getTwilioRequestOTPDataPhoneNumber(
        data
      );
      if (status) {
        this.setState({ localPhone: phoneNumber });
      }
    }
    if (prevProps.getTwilioGetFileData !== this.props.getTwilioGetFileData) {
      const data = twilioSelector.getTwilioGetFileDataData(
        this.props.getTwilioGetFileData
      );
      const status = twilioSelector.getTwilioGetFileDataStatus(data);
      const msg = twilioSelector.getTwilioGetFileDataMessage(data);
      const fileType = twilioSelector.getTwilioGetFileDataFileType(data);

      if (status === true) {
        // const docStream = twilioSelector.getTwilioGetFileDataFile(data);

        // const documentName = "File";
        // const linkSource = `data:${fileType};base64,${docStream}`;
        // const downloadLink = document.createElement("a");

        // const fileName = documentName;
        // downloadLink.href = linkSource;
        // downloadLink.download = fileName;
        // downloadLink.click();
        console.log("a")
       // window.location.href = process.env.REACT_APP_FILE_MANAGER_DOWNLOAD_URL + "FileName" + this.state.localFileName + "&OtpCode" + this.state.otpNo
        //window.open(process.env.REACT_APP_FILE_MANAGER_DOWNLOAD_URL + "FileName" + this.state.localFileName + "&OtpCode" + this.state.otpNo) || window.location.assign(process.env.REACT_APP_FILE_MANAGER_DOWNLOAD_URL + "FileName" + this.state.localFileName + "&OtpCode" + this.state.otpNo)
       // window.open(process.env.REACT_APP_FILE_MANAGER_DOWNLOAD_URL + "FileName" + this.state.localFileName + "&OtpCode" + this.state.otpNo );
        window.open(process.env.REACT_APP_FILE_MANAGER_DOWNLOAD_URL + "FileName=" + this.state.localFileName + "&OtpCode=" + this.state.otpNo, "_blank");
      } else {
        this.setState({
          openCustomToast: true,
          toastMessage: msg,
        });
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangeOtpNo = (event) => {
    this.setState({ otpNo: event.target.value });
  };

  onClickNext = () => {
    const data = twilioSelector.getTwilioRequestOTPDataData(
      this.props.getTwilioRequestOTPData
    );
    const status = twilioSelector.getTwilioRequestOTPDataStatus(data);
    if (status === true) {
      const { getTwilioGetFile } = this.props;
      getTwilioGetFile(this.state.localFileName, this.state.otpNo);
    }
  };

  onClickHere = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  validateTextInput = () => {
    const { policyNo } = this.state;
    return _.isEmpty(policyNo);
  };

  onClickBack = () => {
    window.history.back();
  };

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openCustomToast: false });
  };

  onClickResend = () => {
    this.setState({ showSendOtp: false });
    const data = twilioSelector.getTwilioGetFileStatusDataData(
      this.props.getTwilioGetFileStatusData
    );
    const status = twilioSelector.getTwilioGetFileStatusDataStatus(data);
    const msg = twilioSelector.getTwilioGetFileStatusDataMessage(data);

    if (status === true) {
      const { getTwilioRequestOTP } = this.props;
      getTwilioRequestOTP(this.state.localFileName);
    } else {
      this.setState({
        openCustomToast: true,
        toastMessage: msg,
        // loadingAction: false,
      });
    }
    this.setState({ seconds: 120 });
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error, localPhone } = this.state;
    const data = twilioSelector.getTwilioGetFileDataData(
      this.props.getTwilioGetFileData
    );
    const status = twilioSelector.getTwilioGetFileDataStatus(data);
    return (
      <Grid container direction={"column"} spacing={2}>
        {status ? (
          <Grid
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <img src={Image.accountExist} />
          </Grid>
        ) : (
          false
        )}
        {status ? (
          <Grid
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <CustomText>Downloading the file to Your device</CustomText>
          </Grid>
        ) : (
          false
        )}

        {status ? (
          false
        ) : (
          <Grid item>
            <CustomText
              design={classes.renewNowTextStyle}
              style={{ color: "#2c3034" }}
            >
              Enter OTP (One Time Password)
            </CustomText>
          </Grid>
        )}

        {status ? (
          false
        ) : (
          <Grid item>
            <CustomTextInput
              title={
                this.state.showSendOtp
                  ? "Click Send OTP button to get OTP"
                  : `An OTP has been sent to ${localPhone} and valid for 2 minutes`
              }
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={this.state.otpNo}
              onChange={this.onChangeOtpNo}
              errorMessage={errorMsg}
              error={error}
              endAdornment={
                this.state.showSendOtp ? (
                  false
                ) : (
                  <button
                    style={{
                      border: "none",
                      cursor: this.state.seconds < 1 ? "pointer" : false,
                      backgroundColor: "#fff",
                      color: "#495057",
                      fontWeight: "600",
                    }}
                    onClick={
                      this.state.seconds < 1 ? this.onClickResend : false
                    }
                  >
                    {this.state.seconds > 0 ? this.state.seconds : "Resend"}
                  </button>
                )
              }
            />
          </Grid>
        )}

        {status ? (
          false
        ) : (
          <Grid item xs={12} md={8}>
            <CustomButton
              title={
                this.state.showSendOtp
                  ? "Send OTP"
                  : "Validate OTP and Download"
              }
              design={classes.nextButtonStyle}
              onClick={
                this.state.showSendOtp ? this.onClickResend : this.onClickNext
              }
            />
          </Grid>
        )}
      </Grid>
    );
  };

  render() {
    const {
      classes,
      getTwilioGetFileLoading,
      getTwilioRequestOTPLoading,
      getTwilioGetFileStatusLoading,
    } = this.props;
    const {
      height,
      width,
      openCustomToast,
      toastMessage,
      visibleErrorPrompt,
    } = this.state;
    const data = twilioSelector.getTwilioGetFileStatusDataData(
      this.props.getTwilioGetFileStatusData
    );
    const status = twilioSelector.getTwilioGetFileStatusDataStatus(data);
    const msg = twilioSelector.getTwilioGetFileStatusDataMessage(data);
    return (
      <div className={classes.root}>
        <Helmet>
          <title>File Manager</title>
        </Helmet>

        <CustomBoardFileManagerV2
          children={this.renderChildren()}
          height={height}
          width={width}
        />
        <CustomToast
          closeAutoHide={true}
          open={openCustomToast}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        <FileManagerErrorPrompt
          visibleErrorPrompt={visibleErrorPrompt}
          errorMsg={msg}
        />
        {this.state.loadingAction ? <LoadingOverlay loading={true} /> : false}
        {getTwilioGetFileLoading ? <LoadingOverlay loading={true} /> : false}
        {getTwilioRequestOTPLoading ? <LoadingOverlay loading={true} /> : false}
        {getTwilioGetFileStatusLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
    height: window.innerWidth < 600 ? false : "100vh",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 15,
  },
  nextButtonStyle: {
    //width: 150,
    marginTop: 10,
    marginBottom: 10,
    height: 40,
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "center",
    color: "#2c3034",
    marginBottom: 20,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
});

function mapStateToProps(state) {
  return {
    getTwilioGetFileStatusData: selector.getTwilioGetFileStatusData(state),
    getTwilioGetFileStatusLoading: selector.getTwilioGetFileStatusLoading(
      state
    ),
    getTwilioGetFileStatusStatus: selector.getTwilioGetFileStatusStatus(state),
    getTwilioRequestOTPData: selector.getTwilioRequestOTPData(state),
    getTwilioRequestOTPLoading: selector.getTwilioRequestOTPLoading(state),
    getTwilioRequestOTPStatus: selector.getTwilioRequestOTPStatus(state),
    getTwilioGetFileData: selector.getTwilioGetFileData(state),
    getTwilioGetFileLoading: selector.getTwilioGetFileLoading(state),
    getTwilioGetFileStatus: selector.getTwilioGetFileStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTwilioGetFileStatus: (fileName) =>
      dispatch(twilioAction.getTwilioGetFileStatus(fileName)),
    getTwilioRequestOTP: (fileName) =>
      dispatch(twilioAction.getTwilioRequestOTP(fileName)),
    getTwilioGetFile: (fileName, otpCode) =>
      dispatch(twilioAction.getTwilioGetFile(fileName, otpCode)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(FileManager)));
